import { createFileRoute } from "@tanstack/react-router";

// The chat surface for /chats/$chatId is rendered by the workspace layout
// (`_workspace.tsx`), which keeps a single persistent <ChatSurface> shared
// between the full-page view and the side pane. Toggling a chat between the
// two used to unmount one surface and mount the other, so each held its own
// doc subscriptions and pending state split across the two views until a
// refresh. Owning one instance in the always-mounted layout fixes that.
//
// This route exists only so `/chats/$chatId` matches and the layout can read
// the active chat id from the route params; it renders nothing of its own.
export const Route = createFileRoute("/_workspace/chats/$chatId")({
  // Presence overrides this to a generic, link-less label so a private chat's
  // real title is never broadcast (see `presenceWhere`); the tab still shows
  // "Chat" via <HeadContent> for the local user.
  head: () => ({ meta: [{ title: "Chat" }] }),
  component: () => null,
});
